import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faBars, faTimes, faAngleRight, faAngleLeft, faSearch,
    faUser, faUsers, faUserPlus, faUserCheck, faSignOutAlt,
    faRoute, faTasks, faClipboardList, faFileInvoiceDollar,
    faStore, faStoreAlt, faTruck,
    faDesktop, faList, faUnlock, faShieldAlt,
    faChartBar, faFileExport, faFileImport,
    faCog, faWrench, faToolbox, faSlidersH,
    faCheck, faExclamationTriangle, faInfoCircle,
    faEdit, faTrash, faSave, faPlus, faMinus, faEye, faEyeSlash,
    faEnvelope, faPhone, faComments,
    faFile, faFileAlt, faFolder, faFolderOpen,
    faCalendar, faClock, faCalendarAlt,
    faDollarSign, faCreditCard, faReceipt,
    faCar, faMotorcycle, faBus,
    faLaptop, faMobile, faTablet, faServer,
    faLock, faKey, faShield,
    faBell, faBellSlash, faExclamation,
    faHome, faGlobe, faLink, faExternalLinkAlt,
    faImage, faVideo, faMusic, faCamera,
    faHammer, faScrewdriver, faTools,
    faHeart, faStethoscope, faPills,
    faGraduationCap, faBook, faBookOpen,
    faFutbol, faBasketballBall, faVolleyballBall,
    faUtensils, faCoffee, faPizzaSlice,
    faTree, faLeaf, faSun, faMoon, faCloud,
    faBuilding, faWarehouse, faIndustry,
    faGamepad, faFilm, faTv,
    faPlane, faTrain, faShip,
    faBicycle, faSkiing, faSwimmer,
    faStar
} from "@fortawesome/free-solid-svg-icons";

library.add(
    faBars, faTimes, faAngleRight, faAngleLeft, faSearch,
    faUser, faUsers, faUserPlus, faUserCheck, faSignOutAlt,
    faRoute, faTasks, faClipboardList, faFileInvoiceDollar,
    faStore, faStoreAlt, faTruck,
    faDesktop, faList, faUnlock, faShieldAlt,
    faChartBar, faFileExport, faFileImport,
    faCog, faWrench, faToolbox, faSlidersH,
    faCheck, faExclamationTriangle, faInfoCircle,
    faEdit, faTrash, faSave, faPlus, faMinus, faEye, faEyeSlash,
    faEnvelope, faPhone, faComments,
    faFile, faFileAlt, faFolder, faFolderOpen,
    faCalendar, faClock, faCalendarAlt,
    faDollarSign, faCreditCard, faReceipt,
    faCar, faTruck, faMotorcycle, faBus,
    faLaptop, faMobile, faTablet, faServer,
    faLock, faKey, faShield,
    faBell, faBellSlash, faExclamation,
    faHome, faGlobe, faLink, faExternalLinkAlt,
    faImage, faVideo, faMusic, faCamera,
    faHammer, faScrewdriver, faTools,
    faHeart, faStethoscope, faPills,
    faGraduationCap, faBook, faBookOpen,
    faFutbol, faBasketballBall, faVolleyballBall,
    faUtensils, faCoffee, faPizzaSlice,
    faTree, faLeaf, faSun, faMoon, faCloud,
    faBuilding, faWarehouse, faIndustry,
    faGamepad, faFilm, faTv,
    faPlane, faTrain, faShip,
    faBicycle, faSkiing, faSwimmer,
    faStar
);

export { FontAwesomeIcon };

